
import Vue from "vue";
import axios from "axios";
import { clone } from "../util/clone";
import BillingReview from "@/components/BillingReview.vue";
import InvoiceReview from "@/components/InvoiceReview.vue";
import { INVOICE_ENDPOINT } from "../constants/EndPoints";
import {
  IPaymentRequest,
  IBillingInfo,
  IInvoicePayment,
  IAuthBasic
} from "../types";
import AuthBasic from "../data/authBasic";
import store from "../store";
import { mapGetters } from "vuex";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";

export default Vue.extend({
  name: "invoice-payment",
  mixins: [AppPropsMixin],
  components: {
    BillingReview,
    InvoiceReview
  },
  data() {
    return {
      paymentRequest: {} as IPaymentRequest,
      formContent: "" as string,
      formAction: "" as string
    };
  },
  computed: {
    billingInfo(): IBillingInfo {
      //@ts-ignore
      return store.getters.billingModule.getBilling;
    },
    invoicePayment(): IInvoicePayment {
      //@ts-ignore
      return store.getters.invoiceModule.getInvoicePayment;
    }
  },
  methods: {
    getFormToSubmit() {
      //@ts-ignore
      this.appProps.loadingPayeezyForm = true;
      //@ts-ignore
      this.appProps.failedPayeezyFormCreation = false;

      let url = INVOICE_ENDPOINT.CREATE_SUBMIT_HTML;
      this.populateRequestObject(this.paymentRequest);

      axios
        .post(url, this.paymentRequest, { auth: AuthBasic })
        .then(response => {
          this.formContent = response.data.formContent;
          this.formAction = response.data.formAction;
          //@ts-ignore
          this.appProps.failedPayeezyFormCreation = false;
        })
        .catch(
          error =>
            //@ts-ignore
            (this.appProps.failedPayeezyFormCreation = true)
        )
        .finally(
          () =>
            //@ts-ignore
            (this.appProps.loadingPayeezyForm = false)
        );
    },
    populateRequestObject(payrequest: IPaymentRequest) {
      payrequest.orderID = "111";
      payrequest.sessionID = "222";

      payrequest.billingInfo = clone(this.billingInfo);
      payrequest.invoicePayment = clone(this.invoicePayment);
    },
    submitPayeezyForm() {
      //@ts-ignore
      this.$refs.payeezySubmitForm.submit();
    }
  }
});
